import React from 'react';

import { View } from 'react-native';

import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = { description: string };

function SettingsDialogDescription({ description }: Props) {
    return (
        <View style={styles.root}>
            <Text
                style={styles.description}
                center
                category={ETextCategory.body1}
                color={ETextColor.light_grey}
                {...(isWeb && { tabIndex: 0 })}
            >
                {description}
            </Text>
        </View>
    );
}

export default SettingsDialogDescription;
